import { ApiGetAction } from '../../models/api-action.models';
import { ApiMutatorStateModel } from './api-state.models';

export class ApiSetMetadata<T extends object = object> {
  static type = '[API] Set metadata';

  constructor(
    readonly action: ApiGetAction<T>,
    readonly metadata: ApiMutatorStateModel<T>,
  ) {}
}
